import React from "react";
import img1 from "../assets/images/sidom/fotos/Nosotros/valores/2.png";
import img2 from "../assets/images/sidom/fotos/Nosotros/valores/5.png";
import img4 from "../assets/images/sidom/fotos/Nosotros/valores/7.png";
import img5 from "../assets/images/sidom/fotos/Nosotros/valores/8.png";
import img6 from "../assets/images/sidom/fotos/Nosotros/valores/rainbow-solid.png";
import img7 from "../assets/images/sidom/fotos/Nosotros/valores/e.png";

export default function VisionMissionValues() {
  return (
    <div className="  ">
      <div className=" container flex flex-col justify-center items-center gap-8  ">
        <div className="flex flex-col mt-[60px]   md:flex-row  overflow-hidden  w-full justify-between items-center ">
          <div className="w-[60%]  justify-start items-star">
            {" "}
            <h3 className="text-sidom-orange  font-bold text-3xl  mb-2">
              Nuestra visión
            </h3>
          </div>
          <div className="w-[40%]  flex justify-start items-star">
            <p className="max-w-screen-md font-bold text-sidom-dark dark:text-sidom-light">
              Ser la solución tecnológica global, simplificando el comercio
              internacional con innovación y talento, agregando valor a las
              mejores compañías del mundo, nuestros clientes.
            </p>
          </div>
        </div>

        <div className="flex flex-col  mt-[60px] mb-[30px] md:flex-row  overflow-hidden  w-full justify-between items-center  ">
          <div className="w-[60%]  ">
            <h3 className="text-sidom-orange font-bold text-3xl  mb-2">
              Nuestra misión
            </h3>
          </div>
          <div className="w-[40%]  flex justify-start items-start">
            <p className=" text-sidom-dark font-bold dark:text-sidom-light">
              Hacemos simple lo complejo.
            </p>
          </div>
        </div>

        <div className="flex flex-col  mt-[60px] mb-[100px] md:flex-row  overflow-hidden  w-full justify-between items-center  ">
          <div className="w-[60%] ">
            <h3 className="text-sidom-orange font-extrabold text-3xl  mb-4">
              Nuestros valores
            </h3>
          </div>

          <div className="w-[40%] flex justify-start items-start">
            <ul className="flex flex-col justify-start items-start  text-sidom-dark font-bold dark:text-sidom-light">
              <li className="flex justify-center gap-1 mb-4  items-center ">
                <img src={img2} className=" w-6" alt="img" />
                #ToTheMoon
              </li>
              <li className="flex justify-center gap-1 mb-4   items-center">
                <img src={img5} className=" w-6" alt="img" />
                #somosTRANSPARENTES
              </li>
              <li className="flex justify-center gap-1 mb-4   items-center">
                <img src={img4} className=" w-6" alt="img" />
                #somosINNOVACIÓN
              </li>
              <li className="flex justify-center gap-1 mb-4   items-center">
                <img src={img7} className=" w-6" alt="img" />
                #somosEXCELENCIA
              </li>
              <li className="flex justify-center gap-1 mb-4   items-center">
                <img src={img1} className=" w-6" alt="img" />
                #somosCUSTOMEROBSESSED
              </li>
              <li className="flex justify-center gap-1 mb-4  items-center">
                <img src={img6} className="w-6" alt="img" />
                #somosDIVERSIDAD
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
